import React from 'react';
import { WMSTileLayer } from 'react-leaflet';

const WmsTerracotta = ({ transparent, url }) => (
  <WMSTileLayer transparent={transparent} url={url} />
);

export default WmsTerracotta;
